import { Link } from 'react-router-dom';
import VideoCard from '@/components/base/VideoCard';
import { videos } from '@/mocks/videos';

export default function FeaturedVideos() {
  const featuredVideos = videos.filter((v) => v.featured);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 mb-1 font-heading">
              精选推荐
            </h2>
            <p className="text-sm text-foreground-600">编辑精选的高分影视佳作</p>
          </div>
          <Link
            to="/category"
            className="flex items-center gap-1 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors duration-200 whitespace-nowrap"
          >
            查看全部
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {featuredVideos.slice(0, 4).map((video, index) => (
            <div key={video.id} data-product-shop className={index === 0 ? 'sm:col-span-2 sm:row-span-2' : ''}>
              <VideoCard video={video} size={index === 0 ? 'large' : 'normal'} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}